import {useNavigate, useSearchParams} from "react-router-dom";
import {PersonEntity, personSelector, personType, useGetPersonQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {PersonProfile} from "../../components/profile/PersonProfile/PersonProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const PersonProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.person.alt", "User") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <PersonProfilePage id={id}/>;
};

export const PersonProfilePage = (props: Props) => {
  const {id} = props;

  const selectPerson = useMemo(() => {
    return personSelector()
  }, []);

  const {person, isFetching} = useGetPersonQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      person: selectPerson(result),
      isFetching: result.isFetching
    })
  });

  const getPermissions = useCallback((entity: PersonEntity | undefined) => {
    if (entity) {
      if (entity.type === personType.user) {
        return ["view", "person_view", "person_user_view"]
      } else if (entity.type === personType.driver) {
        return ["view", "person_view", "person_driver_view"]
      }
    }

    return ["view", "person_view"]
  }, [])

  return (
    <EntityProfilePage
      entity={person}
      isLoading={isFetching}
      permissions={getPermissions}
    >
      {(entity) => (
        <PersonProfile person={entity}/>
      )}
    </EntityProfilePage>
  )
};
